export default __webpack_public_path__ + "static/media/quickLogo.1fdb8327.svg";